import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { getRequisition } from "../../../services/OtherService";
import { RequisitionStatusBadge } from "./index";
const RequisitionDetails = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const { user_permission, role } = useSelector((state) => state.auth.user);
  const [requisition, setRequisition] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    fetchRequisition(id);
    return () => {
      setRequisition(null);
      setLoading(false);
      setError(null);
    };
  }, [id]);

  const fetchRequisition = async (id) => {
    setLoading(true);
    try {
      const response = await getRequisition(id);
      setRequisition(response.data.data);
    } catch (err) {
      setError(
        err?.response?.data?.message || "Error fetching requisition details"
      );
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card card-body">
              <div className="text-center fw-bold">Loading...</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  if (error) {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card card-body">
              <div className="alert alert-danger">{error}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="d-flex align-items-center justify-content-between p-3 border-bottom">
              <div className="d-flex align-items-center">
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm rounded-circle"
                  style={{ padding: "5px 9px" }}
                  onClick={() => navigate("/requisition")}
                >
                  <i className="fa-solid fa-arrow-left"></i>
                </button>
                <h4 className="mb-0 ms-2">Requisition Details</h4>
              </div>
              {(role === "Admin" || user_permission.manage_material) && (
                <button
                  type="button"
                  onClick={() => {}}
                  className="btn btn-primary btn-sm"
                >
                  <i className="fa-solid fa-pen-to-square me-1" />
                  <span>Edit </span>
                </button>
              )}
            </div>
            <div className="card-body p-0">
              {requisition && (
                <div>
                  <div className="row p-3">
                    <div className="col-md-4">
                      <h5>Reference No: {requisition.reference_no}</h5>
                      <p>Fulfillment Date: {requisition.fulfillment_date}</p>
                      <p>
                        Status:{" "}
                        <RequisitionStatusBadge status={requisition.status} />
                      </p>
                    </div>
                    <div className="col-md-4">
                      <p>
                        Requested By: {requisition.requested_by?.name || "N/A"}
                        <p>Requested At: {requisition.created_at}</p>
                      </p>
                    </div>
                    <div className="col-md-4">
                      <h5>Total Materials: {requisition.total_material}</h5>
                      <h5>Total Quantites: {requisition.total_quantity}</h5>
                    </div>
                  </div>

                  <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                    <table
                      id="empoloyees-tblwrapper"
                      className="table ItemsCheckboxSec dataTable no-footer mb-0"
                    >
                      <thead>
                        <tr>
                          <th>Material</th>
                          <th>Purpose</th>
                          <th>Requested Qty</th>
                          <th>Fulfilled Qty</th>
                        </tr>
                      </thead>
                      <tbody>
                        {requisition.items.map((item) => (
                          <tr key={item.id}>
                            <td>{item.product_name}</td>
                            <td>{item.purpose}</td>
                            <td>{item.requested_quantity || "N/A"}</td>
                            <td>{item.fulfilled_quantity}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                      <p className="px-3">
                        Total Material: {requisition.items.length}
                      </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequisitionDetails;
